// Initialize Firebase
import * as firebase from "firebase";
var config = {
    apiKey: "AIzaSyC0UoBomQoBDKNqDLHadTDrnDLKYRDmbuo",
    authDomain: "learn-e4341.firebaseapp.com",
    databaseURL: "https://learn-e4341.firebaseio.com",
    storageBucket: "learn-e4341.appspot.com",
    messagingSenderId: "632068953078"
  	};
var firebaseApp = firebase.initializeApp(config);
export default firebaseApp


// WEBPACK FOOTER //
// ./src/data/FirebaseApp.js